import React, { useState } from "react"
import { Select, DatePicker, Space, Input } from "antd"

const FlyersRequestFilters = ({filters, onFiltersChange}) => {
  const [searchField, setSearchField] = useState("userEmail")
  const searchBy = (
    <Select defaultValue="userEmail" className="select-before" onChange={value => setSearchField(value)}>
      <Select.Option value="trackingNo">Tracking No</Select.Option>
      <Select.Option value="userEmail">User Email</Select.Option>
    </Select>
  );

  return (
    <Space size="large" wrap>
      <div>
        Status :{` `}
        <Select 
          placeholder="ALL"
          style={{ width: 120 }}
          allowClear 
          onChange={value => onFiltersChange({...filters, status: value})}
        >
          <Select.Option value="POSTED">POSTED</Select.Option>
          <Select.Option value="REQUESTED">REQUESTED</Select.Option>
        </Select>
      </div>

      <div>
        <Input.Search 
          addonBefore={searchBy}
          placeholder="Search" 
          onSearch={term => onFiltersChange({...filters, search: term, searchField }) } 
        />
      </div>

      <div>
        Requested At :{` `}
        <DatePicker.RangePicker
          value={[filters.startDate, filters.endDate]}
          onChange={dates => (dates 
              ? onFiltersChange({...filters, startDate: dates[0], endDate: dates[1]}) 
              : onFiltersChange({...filters, startDate: undefined, endDate: undefined})
          )}
        />
      </div>
    </Space>
  )
}

export default FlyersRequestFilters;
